import styled from "styled-components";

const WhyCss = styled.div`
  font-family: "Poppins";
  text-align: center;
  align-items: center;
  color: white;
  background-color: #0a181a;
  .wrapper {
    .title {
      transform: translateX(-100%);
      transition: 2s ease;
      padding-top: 1em;
      color: white;
      font-family: Poppins;
      font-size: 40px;
      font-style: normal;
      font-weight: 300;
      line-height: 60px;
      letter-spacing: 0em;
      text-align: center;
      &.fadeIn {
        transform: translateX(0%);
        opacity: 1;
      }
      @media (max-width: 1000px) {
        font-size: 36px;
      }

      @media (max-width: 600px) {
        font-size: 28px;
      }

      @media (max-width: 400px) {
        font-size: 26px;
      }
    }
    .cards {
      display: flex;
      justify-content: space-around;
      padding: 4rem 16rem;

      @media (max-width: 1600px) {
        padding: 4rem 10rem;
      }
      @media (max-width: 1000px) {
        padding: 2rem 8rem;
      }
      @media (max-width: 800px) {
        padding: 2rem 4rem;
      }

      @media (max-width: 600px) {
        flex-direction: column;
      }
      .card {
        width: 20vw;
        padding: 3rem 2rem 2rem 2rem;
        border-radius: 20px;
        background-color: #23545db2;
        cursor: pointer;
        &:hover {
          .image,
          .text {
            transition: transform 1s;
            transform: scale(1.1);
          }
        }
        @media (max-width: 1000px) {
          width: 11rem;
          padding: 2rem 1rem 1rem 1rem;
          border-radius: 15px;
        }
        @media (max-width: 700px) {
          width: 10rem;
          padding: 2rem 1rem 1rem 1rem;
          border-radius: 15px;
        }
        @media (max-width: 600px) {
          width: 70vw;
          padding: 2rem 1rem 2rem 1rem;
          margin-bottom: 1rem;
          margin-left: auto;
          margin-right: auto;
        }
        .image {
          width: 30%;
          object-fit: contain;
          margin-left: auto;
          margin-right: auto;
          padding-bottom: 1em;
          @media (max-width: 1400px) {
            width: 30%;
          }
          @media (max-width: 1000px) {
            width: 40%;
          }
          @media (max-width: 600px) {
            width: 30%;
          }
        }
        .text {
          padding-top: 2rem;
          color: white;
          font-family: Poppins;
          font-size: 20px;
          font-style: normal;
          font-weight: 400;
          line-height: 30px;
          letter-spacing: 0em;
          text-align: center;
          @media (max-width: 1400px) {
            font-size: 15px;
            line-height: 20px;
          }
          @media (max-width: 1000px) {
            font-size: 14px;
          }
          @media (max-width: 600px) {
            font-size: 18px;
          }
        }
      }
    }
  }
`;

export default WhyCss;
